/******************************************************************************
 * Created Date: Tuesday Febuary 15th 2022                                    *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thu Feb 17 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/components/List/util/UsersDataTable.js *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

const findUserIndex = ({ res, users }) =>
  users.findIndex(obj => obj.id === res?.data?.user_id);

/* Users Table
 * Used HTTP API METHOD response/res to create/update/delete the affected row(s),
 * instead of making multiple API CALL and updating the entire table */

const updateAffectedRow = ({ res, users }) => {
  const userIndex = findUserIndex({ res, users });
  const updatedUser = { id: res?.data?.user_id, ...res?.data };
  const updatedUsersList = [...users];
  if (userIndex >= 0) {
    updatedUsersList.splice(userIndex, 1, updatedUser);
  } else {
    updatedUsersList.unshift(updatedUser);
  }

  return updatedUsersList;
};

const deteteAffectedRow = ({ res: deleteResponse, users, userId }) => {
  /* The Delete response don't have the user id so we need to map it on the res object */
  const res = {
    ...deleteResponse,
    data: {
      user_id: userId
    }
  };

  const userIndex = findUserIndex({ res, users });
  const updatedUsersList = [...users];
  updatedUsersList.splice(userIndex, 1);

  return updatedUsersList;
};

const createNewRow = ({ res, users }) => {
  const newUser = { id: res?.data?.user_id, ...res?.data };
  const updatedUsersList = [...users];
  updatedUsersList.unshift(newUser);

  return updatedUsersList;
};

const UsersDataTable = {
  create: createNewRow,
  update: updateAffectedRow,
  delete: deteteAffectedRow
};

export default UsersDataTable;
